import { errorLog } from '@utils/logs';
import { toast } from 'react-toastify';
import TOAST_OPTIONS from 'constants/toastOptions';
import { STRINGS } from 'constants/strings';

export const showPromiseError = (err) => {
  errorLog(err);
  toast.error(STRINGS.AN_ERROR_OCCURED_ON_SERVER__TRY_AGAIN, TOAST_OPTIONS);
};
